module.exports = __webpack_public_path__ + "h5/img/替换内容1.a2dee04a.png";